module.exports = __webpack_public_path__ + "static/media/nancy.b825434c.jpg";